import { useEffect, useRef, useState } from 'react';
import { useApp } from '../app-context';
import { TSPage } from '../components/commons';
import { DashService } from '../services/DashService';
import { Utils } from '../Utils';

import './LoginPage.scss';

const LoginPinPage = function ({ name, pageState }) {
    const [state, dispatcher] = useApp();

    const [stateError, setStateError] = useState();
    const [stateBusy, setStateBusy] = useState(false);
    const [stateSuccess, setStateSuccess] = useState(false);
    const [stateReplyLocked, setStateReplyLocked] = useState(false);

    const replyTimeoutRef = useRef(null);

    useEffect(() => {
        return () => {
            if (replyTimeoutRef.current) clearTimeout(replyTimeoutRef.current);
        };
    }, []);

    const handleBack = () => {
        dispatcher({ action: "closePage", params: { id: "loginPin" } });
    };

    const handleSubmitReply = (e) => {
        e.preventDefault();
        if (stateBusy || stateReplyLocked) return;

        setStateError(undefined);
        setStateBusy(true);
        setStateSuccess(false);
        DashService.requestLoginCode(state.loginPhone, state.loginPid, state.loginMethod)
            .then((data) => {
                dispatcher({ action: "setLoginKey", params: { key: data.key, phone: state.loginPhone, pid: state.loginPid, method: state.loginMethod }});

                setStateSuccess(true);
                setStateError("הקוד נשלח בהצלחה");
                setStateReplyLocked(true);

                replyTimeoutRef.current = setTimeout(() => {
                    setStateError(undefined);
                    setStateSuccess(false);
                    setStateReplyLocked(false);
                }, 4000);
            })
            .catch(ex => {
                setStateSuccess(false);
                setStateError(ex?.message || "מצטערים, לא ניתן לבצע את הפעולה המבוקשת במועד זה");
            })
            .finally(() => {
                setStateBusy(false);
            });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (stateBusy) return;

        setStateError(undefined);
        if (!document.getElementById("loginPin").value) {
            setStateError("יש להזין את קוד האימות שקיבלתם בסמס");
            return;
        }

        setStateBusy(true);
        DashService.login(state.loginKey, document.getElementById("loginPin").value)
            .then((data) => {
                if (!data?.token)
                    throw Error("מצטערים, לא הצלחנו להתחבר במועד זה")

                try {
                    window.localStorage.setItem("dashTkn", data.token);
                } catch (ex) { console.error(ex); }

                dispatcher({ action: "loggedIn", params: { token: data.token } });

                return DashService.tokenLogin(data.token);
            })
            .then((data) => {
                if (!data.profile)
                    throw Error("לא מצאנו את נתוני הפוליסה המבוקשת :(");
                dispatcher({ action: "gotProfile", params: { profile: data.profile, policies: data.policies } });
            })
            .catch(ex => {
                if (ex?._data?.status === 1015 || (ex?._data?.status === 1016)) {
                    Utils.displaySimpleMsg(dispatcher, ex?.message || "מצטערים, נמצאה בעיה בנתוני הכניסה, נא להתחיל מחדש");
                    dispatcher({ action: "closePage", params: { id: "loginPin" } });
                } else {
                    setStateError(ex?.message || "מצטערים, לא ניתן לבצע את הפעולה המבוקשת במועד זה");
                }
            })
            .finally(() => {
                setStateBusy(false);
            });
    };

    return (
        <TSPage name={name} pageState={pageState} className="fading">
            <img className="bg full" src="/img/login/bg.svg" alt="" />
            <img className="bg" src="/img/login/back-elements.svg" alt="" />
            <img className="bg front" src="/img/login/front-elements.svg" alt="" />


            <div className="content">
                <form onSubmit={handleSubmit}>
                    <button className="backBtn" type="button" onClick={handleBack}>
                        <img src="/img/close.svg" alt="close" />
                    </button>
                    <h1 className="header">הזנת קוד אימות</h1>

                    <div className="field">
                        <input id="loginPin" type="text" inputMode="numeric" autoComplete="one-time-code" placeholder="קוד אימות" />
                    </div>
                    { stateError ?
                        <div className={`error-msg${stateSuccess ? ' success' : ''}`}>
                            {stateError}
                        </div>
                    : undefined }
                    <div><button className="yellow submit">התחבר</button></div>
                    <div className="activationCode"><a id='activationRply' href="#" className={stateReplyLocked ? "disabled" : ""} onClick={handleSubmitReply}>לקבלת קוד חדש</a></div>
                </form>
            </div>
        </TSPage>
    );
}

export { LoginPinPage };